module.exports = __webpack_public_path__ + "img/m1.cfcd89b4.webp";